/**
 * A fresh `Idempotency-Key`.
 *
 * Shared by the two writes that take one: `POST /bookings`, where the header is
 * a nice-to-have, and `POST /membership`, where it is REQUIRED — that request
 * 400s without it.
 *
 * A uuid v4 built on `Math.random`, which is the right trade here: the key is
 * not a credential and guessing one buys nothing (both endpoints are
 * authenticated and scoped to the caller), so all it has to be is unique among
 * the keys THIS user might send. A cryptographic source would mean adding
 * `expo-crypto` — a native module, so a dev-client rebuild — to make a value
 * nobody attacks harder to guess.
 *
 * Mint it where the key's LIFETIME belongs, not per call: one per visit to a
 * confirm screen, so every retry of that one press replays the original booking
 * or membership instead of creating a second one.
 */
export function newIdempotencyKey(): string {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (char) => {
    const random = Math.floor(Math.random() * 16);
    // The version-4 layout: 'x' is any nibble, 'y' is one of 8/9/a/b.
    const value = char === 'x' ? random : (random & 0x3) | 0x8;
    return value.toString(16);
  });
}
